import { Lock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

export const eur = (n, d = 2) => (n == null ? "—" : Number(n).toLocaleString("fr-FR", { minimumFractionDigits: d, maximumFractionDigits: d }) + " €");
export const pct = (n) => (n == null ? "—" : `${n > 0 ? "+" : ""}${Number(n).toLocaleString("fr-FR", { maximumFractionDigits: 1 })} %`);
export const fdate = (d) => (d ? new Date(d).toLocaleDateString("fr-FR") : "—");

export const Trend = ({ v, className = "" }) => <span className={`font-semibold tabular-nums ${v > 0 ? "text-red-600" : v < 0 ? "text-emerald-600" : "text-slate-500"} ${className}`} data-testid="trend">{pct(v)}</span>;

export const PlanLock = ({ required = "pro", children, compact = false }) => {
  const navigate = useNavigate();
  const label = required === "premium" ? "Premium" : "Pro";
  return (
    <div className={`rounded-2xl border border-dashed border-slate-300 bg-slate-50 ${compact ? "p-3" : "p-6"} text-center`} data-testid={`plan-lock-${required}`}>
      <Lock className="w-5 h-5 mx-auto text-slate-400" />
      <p className="text-sm font-semibold text-slate-700 mt-2">Disponible avec {label}</p>
      {children && <p className="text-xs text-slate-500 mt-1">{children}</p>}
      {!compact && <Button size="sm" variant="outline" className="mt-3 rounded-lg" onClick={() => navigate("/app/settings#abonnement")} data-testid={`plan-lock-cta-${required}`}>Voir les offres</Button>}
    </div>
  );
};

export const Sparkline = ({ points = [], width = 240, height = 56 }) => {
  const vals = points.map((p) => p.price);
  if (vals.length < 2) return <p className="text-xs text-slate-400">Historique : {vals.length} observation. Le graphique apparaît dès la 2ᵉ facture.</p>;
  const min = Math.min(...vals), max = Math.max(...vals), span = max - min || 1;
  const pts = vals.map((v, i) => `${(i / (vals.length - 1)) * (width - 8) + 4},${height - 6 - ((v - min) / span) * (height - 12)}`);
  return (
    <svg width="100%" viewBox={`0 0 ${width} ${height}`} className="text-blue-600" data-testid="sparkline">
      <polyline fill="none" stroke="currentColor" strokeWidth="2" points={pts.join(" ")} />
      {pts.map((p, i) => <circle key={i} cx={p.split(",")[0]} cy={p.split(",")[1]} r="2.5" fill="currentColor" />)}
    </svg>
  );
};

export const Source = ({ src, est, go }) => src?.invoice_id ? (
  <span className="text-[11px] text-slate-500" data-testid="price-source">Source : facture {src.supplier_name || ""} {src.invoice_number ? `n°${src.invoice_number}` : ""} · <a className="underline" href={`${process.env.REACT_APP_BACKEND_URL}/api/purchases/${est.id}/invoices/${src.invoice_id}/document`} target="_blank" rel="noopener noreferrer">Voir la facture</a></span>
) : null;
